import React, { useEffect, FC, useRef } from 'react';
import { Field, useFormikContext } from 'formik';
import Label from '../label/label';
import DateField from '../date-field/date-field';
import { validateRequiredEndDate, requiredValidation, validateItemName } from '../../utilities/Validation';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import { SiteName } from '../../models/SiteName';
import { useSelector } from 'react-redux';
import { IAppState } from '../../store/types';
import useFocusOnRouteChange from '../../hooks/useFocusOnRouteChange';


export const HolidayDetails:FC = () => {
    const { errors, values, validateField, setFieldValue } = useFormikContext<any>()
    const { translate } = useLocale();
    const site = useSelector((state: IAppState) => state.site.site.label)

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);

    useEffect(() => {
        if ((values.startDate || !values.endDate) && !(values.startDate <= values.endDate )) {
            setFieldValue("endDate", values.startDate)
        }

        if (values.endDate || values.startDate) {
            validateField("startDate");
            validateField("endDate");
        }
    }, [values.endDate, values.startDate])

    return <><div className="w-full p-2 inline-flex justify-start items-center bg-white">
        {values.id ?
            (<div className="ml-8 mr-5 card-details">
                <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.name } }} />
            </div>) : ""}

        <div className="flex flex-col py-4 px-8">
            <div className="mb-2">
                <div className="flex flex-row justify-between" id="nameLabel">
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <Field
                    type="text"
                    name="name"
                    innerRef={inputRef}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" id="nameInput"
                    validate={(value) => validateItemName(value, translate)} />
            </div>
            <div className="mb-2">
                <div className="flex flex-row justify-between" id='startDateLabelId' >
                    <Label
                        htmlFor="startDate"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.startDate)}:</Label>
                    {errors.startDate ? <span className='text-red-600 text-xs'>{errors.startDate}</span> : null}
                </div>
                <div className="flex flex-row justify-between" id='startDatePickerId' >
                    <Field valueName="startDate"
                        type="text"
                        name="startDate"
                        component={DateField}
                        validate={(value) => requiredValidation(value, translate)} />
                </div>
            </div>
        </div>


        <div className="flex flex-col py-4 px-8">
            <div className="mb-2">
                <div className="flex flex-row justify-between" id="siteLabel">
                    <Label
                        htmlFor="siteId"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                    {errors.siteId ? <span className='text-red-600 text-xs'>{errors.siteId}</span> : null}
                </div>
                {values.id
                    ? <Field
                        value={values.site}
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                    : <Field
                        value={site}
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}
            </div>
            <div className="mb-2">
                <div className="flex flex-row justify-between" id='endDateLabelId'>
                    <Label
                        htmlFor="endDate"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.endDate)}:</Label>
                    {errors.endDate ? <span className='text-red-600 text-xs'>{errors.endDate}</span> : null}
                </div>
                <div className="flex flex-row justify-between" id='endDatePickerId'>
                    <Field valueName="endDate"
                        type="text"
                        name="endDate"
                        component={DateField}
                        validate={(value) => validateRequiredEndDate(value, values.startDate, translate)} />
                </div>
            </div>
        </div>
    </div></>;
};
